import { ChangeDetectorRef, Directive, OnChanges, OnDestroy, OnInit, ViewRef } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { NPageFooter } from './page-footer.interface';

@Directive()
export class AbstractPageFooterColumnComponent implements OnInit, OnDestroy, OnChanges {
    column: NPageFooter.IPageFooterColumn | NPageFooter.IPageFooterColumnMobile;
    private initiated = false;

    /**
     * Component subscription
     */
    protected subscriptions = new Subscription();

    constructor(
        private _ref: ChangeDetectorRef,
        private timeoutService: TimeoutService
    ) {
        _ref.detach();
    }

    ngOnInit() {
        this.initiated = true;

        this.detectChanges();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    ngOnChanges() {
        this.detectChanges();
    }

    protected detectChanges() {
        if (this.initiated) {
            this.timeoutService.async(() => {
                if (!(<ViewRef>this._ref).destroyed) {
                    this._ref.detectChanges();
                }
            });
        }
    }
}
